import styled from "styled-components";

export const Container = styled.section`
  margin-top: 15rem;

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 6rem;
  }

  h2.education-title {
    margin-top: 8rem;
  }

  .timeline {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 900px;
    margin: 0 auto;
  }

  .exp-card,
  .education {
    background-color: #2b2b2b;
    border-radius: 1.2rem;
    padding: 2.4rem 2.8rem;
    border-left: 0.3rem solid var(--green);
    transition: 0.25s;
    color: #fff;

    &:hover {
      transform: translateY(-5px);
      border-left-color: var(--pink);
    }
  }

  .education {
    max-width: 900px;
    margin: 0 auto;
  }

  .exp-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.8rem;
    margin-bottom: 1.4rem;

    h3 {
      font-size: 2rem;
      span {
        color: var(--green);
      }
    }

    .period {
      font-size: 1.4rem;
      opacity: 0.7;
      white-space: nowrap;
    }
  }

  .education .exp-header {
    margin-bottom: 0;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    li {
      position: relative;
      padding-left: 2rem;
      font-size: 1.6rem;
      letter-spacing: 0.05rem;
      line-height: 1.6;

      &:before {
        content: "▹";
        position: absolute;
        left: 0;
        color: var(--blue);
      }
    }
  }

  @media (max-width: 480px) {
    .exp-card,
    .education {
      padding: 1.8rem;
    }

    .exp-header h3 {
      font-size: 1.7rem;
    }
  }
`;
